import { createStore } from "vuex";
import axios from "axios";

export default createStore({
  state: {
    activeLink: null,
    baseUrl: process.env.VUE_APP_API_BASE_URL,
    // baseUrl: "https://oversight.hutloop.com/api/",
    showSidebar: false,
    google_map_api_key: "AIzaSyDH8-mG32yFIaaTc07fl8_2ttn6Wl9wkhc",
    message: "",
    propertyFilters: [
      { name: "Featured", value: "featured" },
      { name: "Newest", value: "newest" },
      { name: "Price (Low)", value: "price-low" },
      { name: "Price (High)", value: "price-high" },
      { name: "Beds (least)", value: "bed-least" },
      { name: "Beds (most)", value: "bed-most" },
    ],
    settings: null,
    homepage_settings: null,
    ads: null,
    company_name: null,
  },

  mutations: {
    setActiveLink(state, link) {
      state.activeLink = link;
    },

    setSidebarVisibility(state, isVisible) {
      state.showSidebar = isVisible;
    },

    SET_DATA(state, payload) {
      state.settings = payload;
    },

    SET_HOMEPAGE(state, payload) {
      state.homepage_settings = payload;
    },
    SET_AD(state, payload) {
      state.ads = payload;
    },
  },
  actions: {
    openSidebar({ commit }) {
      commit("setSidebarVisibility", true);
    },

    closeSidebar({ commit }) {
      commit("setSidebarVisibility", false);
    },

    async fetchSettings({ commit, state }) {
      try {
        const response = await axios.get(`${state.baseUrl}settings`);
        commit("SET_DATA", response.data);
        state.company_name = response.data.company_name;
      } catch (error) {
        console.log("API Error:", error);
      }
    },
    async fetchHomePageSettings({ commit, state }) {
      try {
        const response = await axios.get(`${state.baseUrl}homepage-settings`);
        commit("SET_HOMEPAGE", response.data);
      } catch (error) {
        console.log("API Error:", error);
      }
    },

    async fetchAds({ commit, state }) {
      try {
        const response = await axios.get(`${state.baseUrl}adverts`);
        commit("SET_AD", response.data);
      } catch (error) {
        console.log("API Error:", error);
      }
    },
  },
  getters: {
    settings: (state) => state.settings,
    homepage_settings: (state) => state.homepage_settings,
    ads: (state) => state.ads,
  },
  modules: {},
});
